import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e8ea4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = { class: "form-content border-round-xl border-1 border-300 h-full mx-1" }
const _hoisted_3 = { class: "form-header relative pb-65p" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "form-body p-2"
}
const _hoisted_6 = { class: "title font-bold" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = {
  key: 1,
  class: "justify-content-center border-top-1 border-300 mt-auto"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "border-round-xl border-1 border-300 p-2"
}
const _hoisted_12 = {
  key: 0,
  class: "m-1"
}
const _hoisted_13 = {
  key: 1,
  class: "block border-1 border-200 m-2"
}

import { computed } from "vue";
//
type IContentMessage = {
  type: string;
  content: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'flex',
  props: {
    type: null,
    content: null
  },
  setup(__props: any) {

const props = __props as {
  type: string;
  content: any;
};


const openLink = (link: string) => {
  window.open(link, "_blank");
};

const contentsComputed = computed(() => {
  if (isCarousel.value) {
    return props.content.contents.contents;
  } else {
    return [props.content.contents];
  }
});

const contentType = computed(() => props.content.contents.type);
const isCarousel = computed(() => contentType.value === "carousel");

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_unref(isCarousel))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Carousel, {
          value: _unref(contentsComputed),
          numVisible: "2",
          numScroll: "1",
          class: "custom-carousel"
        }, {
          item: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: "cursor-pointer top-0 bottom-0 left-0 right-0 absolute bg-no-repeat bg-cover bg-center border-round-top-xl",
                  style: _normalizeStyle({ backgroundImage: 'url(' + slotProps.data.hero.url + ')' }),
                  onClick: ($event: any) => (openLink(slotProps.data.hero.action.uri))
                }, null, 12, _hoisted_4)
              ]),
              (slotProps.data.body)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(slotProps.data.body.contents[0].text), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(slotProps.data.body.contents[1].text), 1)
                  ]))
                : _createCommentVNode("", true),
              (slotProps.data.footer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_Button, {
                      class: "w-full justify-content-center text-footer shadow-none",
                      type: "button",
                      onClick: ($event: any) => (openLink(slotProps.data.footer.contents[0].action.uri))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(slotProps.data.footer.contents[0].action.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["value"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentsComputed), (content, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "max-w-350",
            key: index
          }, [
            (content.hero)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "cursor-pointer block flex-image-cover border-round-xl border-1 border-300 bg-center bg-cover",
                  style: _normalizeStyle({ backgroundImage: 'url(' + content.hero.url + ')' }),
                  onClick: ($event: any) => (openLink(content.hero.action.uri))
                }, null, 12, _hoisted_10))
              : _createCommentVNode("", true),
            (content.body)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.body.contents, (content, indexC) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: indexC }, [
                      (content.type == 'text')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(content.text), 1))
                        : _createCommentVNode("", true),
                      (content.type == 'separator')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
}
}

})